<template>
  <div class="makercart-tabs-section">
    <div class="tabs-container">
      <div class="tabs-group">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'custom' }"
          @click="$emit('tab-changed', 'custom')"
          @keydown.enter="$emit('tab-changed', 'custom')"
          @keydown.space.prevent="$emit('tab-changed', 'custom')"
          role="button"
          tabindex="0"
        >
          <div class="tab-border-active"></div>
          <span class="tab-text">Custom Makercart</span>
        </div>
        <CustomTooltip
          v-if="localeStore.isSingapore"
          text="Signature Makercarts currently not available in Singapore"
          placement="top"
        >
          <template #trigger>
            <div
              class="tab-item disabled"
              :class="{ active: activeTab === 'signature' }"
            >
              <span class="tab-text">Signature Makercart</span>
            </div>
          </template>
        </CustomTooltip>
        <div
          v-else
          class="tab-item"
          :class="{ active: activeTab === 'signature' }"
          @click="$emit('tab-changed', 'signature')"
          @keydown.enter="$emit('tab-changed', 'signature')"
          @keydown.space.prevent="$emit('tab-changed', 'signature')"
          role="button"
          tabindex="0"
        >
          <span class="tab-text">Signature Makercart</span>
        </div>
        <CustomTooltip
          v-if="localeStore.isSingapore"
          text="Makercrate currently not available in Singapore"
          placement="top"
        >
          <template #trigger>
            <div
              class="tab-item disabled"
              :class="{ active: activeTab === 'makercrate' }"
            >
              <span class="tab-text">Makercrate</span>
            </div>
          </template>
        </CustomTooltip>
        <div
          v-else
          class="tab-item"
          :class="{ active: activeTab === 'makercrate' }"
          @click="$emit('tab-changed', 'makercrate')"
          @keydown.enter="$emit('tab-changed', 'makercrate')"
          @keydown.space.prevent="$emit('tab-changed', 'makercrate')"
          role="button"
          tabindex="0"
        >
          <span class="tab-text">Makercrate</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useLocaleStore } from "@/store/locale";
import CustomTooltip from "@/components/common/CustomTooltip.vue";

/* eslint-disable */

defineProps({
  activeTab: {
    type: String,
    default: "custom",
  },
});

defineEmits(["tab-changed"]);

const localeStore = useLocaleStore();
</script>

<style scoped>
/* Makercart Tabs Section Styles */
.makercart-tabs-section {
  margin-bottom: 24px;
}

.tabs-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 72px;
}

.tabs-group {
  display: flex;
  align-items: stretch;
  position: relative;
  width: max-content;
  border-bottom: 1px solid #d8dae5;
}

.tabs-group :deep(.tt-trigger) {
  display: flex;
  flex: none;
}

.tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  cursor: pointer;
  position: relative;
  flex: none;
  gap: 8px;
}

.tab-item.active {
  position: relative;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #446485;
}

.tab-text {
  font-family: "League Spartan", sans-serif;
  font-size: var(--fs-big);
  line-height: 24px;
  letter-spacing: 0.024px;
  color: #475467;
  font-weight: 400;
  white-space: nowrap;
}

.tab-item.active .tab-text {
  color: #446485;
  font-weight: 700;
}

.tab-item.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.tab-item.disabled .tab-text {
  color: var(--black-body-text);
}

@media (max-width: 768px) {
  .tabs-container {
    flex-direction: column;
    height: auto;
    gap: 16px;
    align-items: stretch;
    overflow-x: auto;
  }

  .tabs-group {
    flex-shrink: 0;
  }

  .tab-text {
    font-size: var(--fs-small);
  }
}

@media (max-width: 480px) {
  .tab-item {
    padding: 8px;
  }
}
</style>
